const CAMPAIGN_ROUTES = {
  path: '/campaign',
  component: () => import('@/pages/Campaign/CampaignPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'campaign.index',
      component: () => import('@/pages/Campaign/CampaignPage.vue'),
    },
    {
      path: 'create',
      name: 'campaign.create',
      component: () => import('@/pages/Campaign/CampaignFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'campaign.edit',
      component: () => import('@/pages/Campaign/CampaignFormPage.vue'),
    },
  ],
};

export default CAMPAIGN_ROUTES;
